(function () {
    angular.module('tmx-app').factory('BranchService', ['$q', 'tmxResource', 'cacheStore',
        function ($q, tmxResource, cacheStore) {


            var branches = tmxResource("CompanyBranch");
            branches.populateDate = function (dateInput) {

                var DateObj = new Date(dateInput);//forming a date object from JSON string
                var DateString = DateObj.toDateString();//getting the date out of the whole date-time
                DateString = DateString + " 17:00:00";//adding custom time
                var DateNew = new Date(DateString);
                return (DateNew.toJSON());//converting the new string to date object
            };

            branches.lookup = {};

            //      LocationService.getLovs().then(function (locations){
            //         branches.lookup.locationLovs = locations.data;  
            //         branches.recievedLov = true;
            //         branches.filterColumn[3].data = locations.data;
            //         branches.gridColumn[3].data = locations.data;
            //       });

            // CompanyService.getLovs().then(function (companies){
            //         branches.lookup.companiesLovs = companies.data;  
            //         branches.filterColumn[4].data = companies.data;
            //         branches.gridColumn[4].data = companies.data;
            //       });

            // UsersService.BMLov().then(function (managers){
            //     branches.lookup.managerLovs = managers.data;
            //     branches.filterColumn[2].data = managers.data;
            //     branches.gridColumn[2].data = managers.data;
            // });

            branches.getUserBranch = function(){
                var deferred = $q.defer();
                var userBranches = cacheStore.get('UserAssociatedBranches');
                if (userBranches) {
                    deferred.resolve(userBranches);
                    return deferred.promise;
                }
                branches.getByAction('GetUserBranch', true).then(function (response) {
                    if (response) {
                        cacheStore.set('UserAssociatedBranches', response);
                        deferred.resolve(response);
                    }
                    else {
                        deferred.reject('Unable to get branches associated with this user.');
                    }
                });
                return deferred.promise;
            }

            branches.CompanyBranchLov = function (id) {

                return branches.getByAction("lov" + "/" + id, true, "get");
            };
            //branches.CompanyBranch=function(id){
            //    return httpPromise=branches.getByAction("getCompanyByBranchId"+"/"+id,true,"get");
            //};
            branches.getCompanyByBranchId = function (id) {
                return branches.getById("getCompanyByBranchId" + "/" + id);
            };
            branches.checkBranchCode = function (branchCode) {
                return branches.getById("CheckCompanyBranch" + "/" + branchCode)
            };

            branches.getBranchesByUserCompany = function () {
                var deferred = $q.defer();
                var currentCompanyBranches = cacheStore.get('CurrentCompanyBranches');
                if (currentCompanyBranches) {
                    deferred.resolve(currentCompanyBranches);
                    return deferred.promise;
                }
                branches.getByAction('GetBranchesByUserCompany', true).then(function (response) {
                    if (response) {
                        cacheStore.set('CurrentCompanyBranches', response);
                        deferred.resolve(response);
                    }
                    else {
                        deferred.reject('Unable to get company branches');
                    }
                });
                return deferred.promise;
            };


            branches.status = [
                {
                    HiddenValue: "active",
                    VisibleValue: "Active"
                },
                {
                    HiddenValue: "inactive",
                    VisibleValue: "Inactive"
                }
            ];
            branches.filterColumn = [

                {
                    field: "BranchName",
                    title: "BranchName",
                    type: "text",
                    search: true,
                    headerTemplate: "<span  ng-class=\"{ 'filter-active' : CompanyBranchesCtrl.isFiltered('BranchName')}\" >{{'BranchName' | translate}} <i class='fa fa-filter' ng-if='CompanyBranchesCtrl.isFiltered(\"BranchName\")' ></i></span>"

                },
                {
                    field: "BranchCode",
                    title: "BranchCode",
                    type: "text",
                    search: true,
                    headerTemplate: "<span  ng-class=\"{ 'filter-active' : CompanyBranchesCtrl.isFiltered('BranchCode')}\" >{{'BranchCode' | translate}} <i class='fa fa-filter' ng-if='CompanyBranchesCtrl.isFiltered(\"BranchCode\")' ></i></span>"

                },
                {
                    field: "UserName",
                    title: "BranchManager",
                    type: "select",
                    data: branches.lookup.managerLovs,
                    isNumber: true,
                    headerTemplate: "<span  ng-class=\"{ 'filter-active' : CompanyBranchesCtrl.isFiltered('UserId')}\" >{{'BranchManager' | translate}}<i class='fa fa-filter' ng-if='CompanyBranchesCtrl.isFiltered(\"UserId\")' ></i></span>"

                },
                //{
                //    field: "LocationId",
                //    title: "Branch Location",
                //    type: "select",
                //    data: branches.lookup.locationLovs,
                //    isNumber: true,
                //    headerTemplate:"<span  ng-class=\"{ 'filter-active' : CompanyBranchesCtrl.isFiltered('LocationId')}\" >Branch Location<i class='fa fa-filter' ng-if='CompanyBranchesCtrl.isFiltered(\"LocationId\")' ></i></span>"
                //
                //},
                {
                    field: "BranchPhoneNumber1",
                    title: "BranchPhone",
                    type: "numeric",
                    search: true,
                    hidden:true,
                    headerTemplate: "<span  ng-class=\"{ 'filter-active' : CompanyBranchesCtrl.isFiltered('BranchPhoneNumber1')}\" >{{'BranchPhone' | translate}}<i class='fa fa-filter' ng-if='CompanyBranchesCtrl.isFiltered(\"BranchPhoneNumber1\")' ></i></span>"

                },
                {
                    field: "Status",
                    title: "Status",
                    type: "select",
                    data: branches.status,
                    hidden:true,
                    headerTemplate: "<span  ng-class=\"{ 'filter-active' : CompanyBranchesCtrl.isFiltered('Status')}\" >{{'Status' | translate}}<i class='fa fa-filter' ng-if='CompanyBranchesCtrl.isFiltered(\"Status\")' ></i></span>"

                },                


            ];
            branches.gridColumn = angular.copy(branches.filterColumn);
            // branches.gridColumn.splice(2,0,{
            //                                 field: "TmxCompanyBranchUsersMapping[0].TmXUser.UserName",
            //                                 title: "Branch Manager",
            //                                 type: "string",
            //                                 search: false
            //                             });

            branches.columns = angular.copy(branches.gridColumn);
            branches.columns.push({ command: [] });
            return branches;

        }]);
})();